module.exports = __webpack_public_path__ + "img/07.211fa2a1.png";